<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeParcelasResumo from "./LinhaDeParcelasResumo.vue";
import LinhaDeParcelasDetalhes from "./LinhaDeParcelasDetalhes.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
]);

const emits = defineEmits([
    "update:alteraParcela",
    "update:alteraAdiantamento",
]);

//==================================================================//
//========================= Altera Parcela =========================//
//==================================================================//

const alteraParcela = (update)=>{

    update.id = props?.parcela?.id;
    emits('update:alteraParcela',update);

};

//==================================================================//
//======================= Altera Adiantamento ======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    emits('update:alteraAdiantamento',update);

};

</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeParcelasResumo
            :dado="props?.dado"
            :parcela="props?.parcela"
            @update:alteraParcela="alteraParcela"
        ></LinhaDeParcelasResumo>

        <LinhaDeParcelasDetalhes
            :dado="props?.dado"
            :parcela="props?.parcela"
            @update:alteraAdiantamento="alteraAdiantamento"
        ></LinhaDeParcelasDetalhes>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>